module.exports = __webpack_public_path__ + "static/img/special2.157bc16c.png";